export default __webpack_public_path__ + "static/media/bannersweb_checoleyenda_rojos_330x330.70190408.jpg";